import {
    AlignmentType,
    PageBreak,
    Document,
    HorizontalPositionAlign,
    HorizontalPositionRelativeFrom,
    ImageRun,
    Paragraph,
    TextRun,
    VerticalPositionAlign,
    VerticalPositionRelativeFrom,
} from 'docx';

export class DocumentCreator {
    // tslint:disable-next-line: typedef
    create([
        title,
        dataBody,
        keywords,
        blobImage,
        imageWidth,
        imageHeight,
        authors,
        caption,
    ]) {
        authors.sort(function (a, b) {
            var keyA = new Date(a.createdAt),
                keyB = new Date(b.createdAt);
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;

            return 0;
        });

        const institutionMap = new Map();
        let institutionCounter = 1;
        const authorsWithInstitution = authors.map((author) => {
            if (!institutionMap.has(author.institution)) {
                institutionMap.set(author.institution, institutionCounter++);
            }
            return {
                ...author,
                institutionNumber: institutionMap.get(author.institution),
            };
        });

        var image;
        var imageCaption;
        if (blobImage) {
            imageCaption = new Paragraph({
                alignment: AlignmentType.CENTER,
                children: [
                    new PageBreak(),
                    new TextRun({
                        text: caption,
                        bold: true,
                    }),
                ],
            });
            image = new Paragraph({
                children: [
                    new ImageRun({
                        data: blobImage,
                        transformation: {
                            width: imageWidth,
                            height: imageHeight,
                        },
                        floating: {
                            horizontalPosition: {
                                relative: HorizontalPositionRelativeFrom.PAGE,
                                align: HorizontalPositionAlign.CENTER,
                            },
                            verticalPosition: {
                                relative:
                                    VerticalPositionRelativeFrom.PARAGRAPH,
                                align: VerticalPositionAlign.BOTTOM,
                            },
                        },
                    }),
                ],
            });
        }

        const document = new Document({
            sections: [
                {
                    children: [
                        //judul
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                new TextRun({
                                    text: title,
                                    allCaps: true,
                                    bold: true,
                                }),
                            ],
                        }),

                        this.createNewLine(),
                        //author name
                        new Paragraph({
                            alignment: AlignmentType.CENTER,
                            children: [
                                ...authorsWithInstitution
                                    .map((author, index) => [
                                        this.createAuthorName(
                                            author.name,
                                            index,
                                        ),
                                        this.createSuperScriptAuthor(
                                            author.institutionNumber,
                                        ),
                                    ])
                                    .reduce(
                                        (prev, curr) => prev.concat(curr),
                                        [],
                                    ),
                            ],
                        }),
                        this.createNewLine(),
                        //author instituion
                        ...Array.from(institutionMap).map(
                            ([institution, number]) =>
                                this.createAuthorInstitution(
                                    institution,
                                    number,
                                ),
                        ),
                        //body
                        this.createNewLine(),
                        ...dataBody
                            .map((data) => {
                                const arr = [];
                                arr.push(
                                    this.createStrucktureHeader(data.keyword),
                                );
                                arr.push(
                                    this.createStructureContent(`${data.text}`),
                                );
                                arr.push(this.createNewLine());
                                return arr;
                            })
                            .reduce((prev, curr) => prev.concat(curr), []),
                        this.createNewLine(),
                        //keyword
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: 'Keywords: ',
                                    bold: true,
                                }),
                                this.createKeyword(keywords),
                            ],
                        }),
                        //image caption
                        imageCaption,
                        //image
                        image,
                    ],
                },
            ],
        });

        return document;
    }

    createAuthorName(name, index) {
        if (index === 0) {
            return new TextRun({
                text: name,
                underline: true,
            });
        } else {
            return new TextRun({
                text: ', ' + name,
            });
        }
    }

    createSuperScriptAuthor(no) {
        return new TextRun({
            text: no.toString(),
            superScript: true,
        });
    }

    createAuthorInstitution(name, index) {
        return new Paragraph({
            alignment: AlignmentType.CENTER,
            children: [
                new TextRun({
                    text: index.toString(),
                    superScript: true,
                }),
                new TextRun({
                    text: name,
                }),
            ],
        });
    }

    createNewLine() {
        return new Paragraph({
            text: ' ',
        });
    }

    createStrucktureHeader(data) {
        return new Paragraph({
            children: [
                new TextRun({
                    text: data,
                    bold: true,
                }),
            ],
        });
    }

    createStructureContent(text) {
        return new Paragraph({
            alignment: AlignmentType.JUSTIFIED,
            children: [
                new TextRun({
                    text,
                }),
            ],
        });
    }

    createKeyword(keywords) {
        var keyword = '';
        for (let index in keywords) {
            index == keywords.length - 1
                ? (keyword += keywords[index])
                : (keyword += keywords[index] + ', ');
        }

        return new TextRun({
            text: keyword,
        });
    }
}
